import React from "react";
import { RouteObject } from "../../interfaces/navigation";
import AdditionalCosts from '../../containers/Buy/AdditionalCosts/EntryPointContainer';
import ScheduleInspection from '../../containers/Buy/ScheduleInspection/EntryPointContainer';
import PickUpPoint from '../../containers/Buy/PickUpPoint/EntryPointContainer';
import CreditRequest from '../../containers/Buy/CreditRequest/EntryPointContainer';
import Financing from '../../containers/Buy/Financing/EntryPointContainer';
import Summary from '../../containers/Buy/Summary/EntryPointContainer';
import CongratulationsPage from "../CongratulationsPage";

const EntryPoint = React.lazy(() => import("../../containers/Buy/BuyContainer"));

const buySubRoutes: RouteObject[] = [
    {
        title: "Buy",
        path: "solicitud-de-credito",
        component: <CreditRequest/>,
        protected: true
    },
    {
        title: "Buy",
        path: "financiacion",
        component: <Financing/>,
        protected: true
    },
    {
        title: "Buy",
        path: "detalle-de-compra",
        component: <Summary/>,
        protected: true
    },
    {
        title: "Buy",
        path: "agendar-inspeccion",
        component: <ScheduleInspection/>,
        protected: true
    },
    {
        title: "Buy",
        path: "punto-de-retiro",
        component: <PickUpPoint/>,
        protected: true
    },
    {
        title: "Buy",
        path: "gastos-operacionales",
        component: <AdditionalCosts/>,
        protected: true
    }
]

export const buyRoutes: RouteObject[] = [
    {
        title: "Buy",
        path: "/comprar",
        component: <EntryPoint/>,
        subRoutes: buySubRoutes,
        protected: true
    },
    {
        title: "Congratulations",
        path: "/comprar/agendar-inspeccion/agradecimiento",
        component: <CongratulationsPage title={"¡Casi estás al volante de tu nuevo auto!"} text={"Ya registramos tu solicitud. Recibirás una notificación cuando confirmemos la fecha de inspección."} />
    },
    {
        title: "Congratulations",
        path: "/comprar/agendar-inspeccion/credito/agradecimiento",
        component: <CongratulationsPage title={"¡Casi estás al volante de tu nuevo auto!"} text={"Ya registramos tu solicitud. Recibirás una notificación cuando confirmemos la fecha de inspección."} />
    }
];